/*!
 */

;(function ( $, window, document, undefined ) {

    var pluginName = 'bePages',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;
        this.rows = [];
        this.rowsPhrases = [];
        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
        Plugin.setEvents();
        Plugin.initParams();
    };

    Plugin.prototype.initParams = function(){
        var Plugin = this;
        Plugin.rows = new Array(4)
        $.each(Plugin.$element.find('.js-section-create'), function (k, v) {
            Plugin.rows[$(v).attr('data-order')-1] = v;
            $(this).find('.delete-row').on('click', function () {
                Plugin.setEditSection($(this))
            });
        })

        $.each(Plugin.$element.find('.js-bePages__phrase'), function (k, v) {
            Plugin.rowsPhrases[$(v).attr('data-order')] = v;
        });

    }

    Plugin.prototype.setEvents = function () {
        var Plugin = this;

        $('[name=page_type_id]').on('change', function () {
            if($(this).val()==1){
                $('.js-bePages__level-2').slideDown();
                $('.js-bePages__level-3').slideUp();
            }else if($(this).val()==2){
                $('.js-bePages__level-3').slideDown();
                $('.js-bePages__level-2').slideUp();
            }else{
                $('.js-bePages__level-2').slideUp();
                $('.js-bePages__level-3').slideUp();
            }
        })

        $('.js-bePages__add-section').on('click', function () {
            Plugin.setSectionData();
        })

        $('.js-bePages__phrases-add').on('click', function () {
            Plugin.addPhrases();
        })

        $('[name=is_candidate_page], [name=is_candidate_page]').on('change', function () {
            $('[name=second_level_template_id]').select2('val','');
        })

    };

    Plugin.prototype.setEditSection = function (element) {
        var Plugin = this;
        Plugin.editSection(element)
        Plugin.rows[element.closest('.js-section-create').data('order') - 1] = null;
        element.closest('.js-section-create').remove();
    }

    Plugin.prototype.addPhrases = function () {
      var Plugin = this;
        if($('[name=text_lists]').val()){
            var dataPhrase = {
                'phrase' : $('[name=text_lists]').val(),
                'order'  : $('[name=order-phrases]').val(),
            }
            $.get(window.location.origin + '/page-phrases').success(function(data) {
                var template = $.templates(data);
                var tmpHtml = template.render(dataPhrase);
                var row = $(tmpHtml);
                Plugin.rowsPhrases[$(row).closest('.js-bePages__phrase').attr('data-order')] = row;
                $('.js-bePages__phrases-container').html('');
                $.each(Plugin.rowsPhrases, function (k, v) {
                    $('.js-bePages__phrases-container').append(v);
                })
                $('[name=text_lists]').val('');
            });
        }
    };

    Plugin.prototype.setSectionData = function () {
        var Plugin = this;
        var order = $('[name=order-section]').val();
        var textFormated = '';
        $.get({
            url: window.location.origin+'/paginas/escape-custom-tags',
            async: false,
            data:{'text': $('[name=content]').summernote('code')},
            success: function(data) { textFormated = data.textFormated}
        });
        data = {
            'image':$('input[name=image-section]').val(),
            'image_responsive':$('input[name=image-section-responsive]').val(),
            'text': $('[name=content]').summernote('code'),
            'section_title': $('[name=section_title_level2]').val(),
            'button_text': $('[name=button_text]').val(),
            'button_url': $('[name=button_url]').val(),
            'order': order,
            'textFormated':textFormated,
        };
        if(data.image && !$('[name=content]').summernote('isEmpty') && order){
            Plugin.loadTemplate(data);
            $('input[name=image-section]').val('');
            $('input[name=image-section-responsive]').val('');
            $('[name=content]').summernote('code','');
            $('[name=order-section]').select2('val','');
            $('[name=button_url]').val('');
            $('[name=button_text]').val('');
            $('[name=section_title_level2]').val('');
        }
    };

    Plugin.prototype.loadTemplate = function (dataSection) {

        var Plugin = this;
        $.get(window.location.origin + '/page-sections').success(function(data) {
            var template = $.templates(data);
            var tmpHtml = template.render(dataSection);
            var row = $(tmpHtml);
            Plugin.rows[Plugin.setOrder($(row))] = $(row);
            $('.js-bePages__sections').html('');
            $.each(Plugin.rows, function (k, v) {
                $(this).find('.delete-row').on('click', function () {
                    Plugin.setEditSection($(this))
                });
               $('.js-bePages__sections').append(v);
            })
        });
    };

    Plugin.prototype.editSection = function (row) {
        var Plugin = this;
        var element = row.closest('.js-section-create');
        $('[name=image-section]').val(element.find('.sectionsImage').val());
        $('[name=image-section-responsive]').val(element.find('.sectionsImageResponsive').val());
        $('[name=content]').summernote('code',element.find('.sectionsText').data('text'));
        $('[name=button_text]').val(element.find('.buttonText').val());
        $('[name=button_url]').val(element.find('.buttonUrl').val());
        $('[name=order-section]').val(element.find('.sectionOrder').val()).trigger('change');
        $('[name=section_title_level2]').val(element.find('.sectionTitle').val());
        $("html, body").animate({scrollTop: $("#edit-section-title").offset().top},'slow');

    };

    Plugin.prototype.setOrder = function (element) {
        var Plugin =  this;
        var newOrder = element.closest('.js-section-create').attr('data-order') - 1;
        var firstEmpty = 0;
        var emptyFind = true;
        if(Plugin.rows[newOrder]!= null) {
            $.each(Plugin.rows, function (k, v) {
                if (v == null && emptyFind) {
                    firstEmpty = k;
                    emptyFind = false;
                }
            });
            var i = 557;
            if (firstEmpty < newOrder) {
                for (i = firstEmpty ; i <= newOrder; i++) {
                    if (i == newOrder) {
                        Plugin.rows[i] = null;
                    }else {
                        Plugin.rows[i] = Plugin.rows[i + 1];
                    }
                }
            } else if (firstEmpty > newOrder) {
                for (i = firstEmpty; i >= newOrder; i--) {
                    if (i == newOrder) {
                        Plugin.rows[i] = null;
                    } else {
                        Plugin.rows[i] = Plugin.rows[i - 1];
                    }
                }
            }
            console.log("/*-");
            console.log(Plugin.rows);

            $.each(Plugin.rows, function (k, v) {
                var showOrder = k + 1;
                if (v != null) {
                    $(v).attr('data-order', showOrder);
                    $(v).find('.order').html(showOrder);
                    $(v).find('.sectionOrder').val(showOrder);
                }
            });
        }
       return newOrder
    }

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );